<template>
  <v-app app>
    <v-navigation-drawer
      v-if="loggedIn"
      persistent
      :mini-variant="miniVariant"
      :clipped="clipped"
      v-model="drawer"
      enable-resize-watcher
      fixed
      app>
      <v-list>
        <v-list-item
          value="true"
          v-for="(item, i) in menuItems"
          :key="i"
          @click="navigate(item.url)" >
          <v-list-item-action>
            <v-icon v-html="item.icon"></v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title v-text="item.title"></v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <v-app-bar
      app
      color="primary"
      dark
     >
      <v-app-bar-nav-icon v-if="loggedIn" @click.stop="drawer = !drawer"></v-app-bar-nav-icon>

      <v-toolbar-title v-text="title"></v-toolbar-title>

    </v-app-bar>
    <v-main>
      <router-view/>
    </v-main>
    <v-footer color="primary" app>
      <span class="white--text">&copy; 2022 Southview PTO</span>
    </v-footer>
  </v-app>
</template>

<script>
import { mapState } from 'vuex';
import firebase from 'firebase';

export default {
  name: 'App',
  data () {
    return {
      clipped: false,
      drawer: false,
      fixed: false,
      miniVariant: false,
      right: false,
      rightDrawer: false,
      title: 'Southview Student Directory'
    }
  },
  mounted() {
    
  },
  computed: {
    menuItems() {
      const menu = [];
      menu.push({icon: 'face', title: 'Students', url:'/students'});
      menu.push({icon: 'grade', title: 'Staff', url: '/staff'});
      menu.push({ icon: 'group_work', title: 'PTO', url: '/pto'});
      if(this.isAdmin) {
        menu.push({icon: 'settings', title: 'Administration', url: '/admin'});
      }
      menu.push({icon: 'info', title: 'Information', url: '/info'});
      menu.push({icon: 'cloud_off', title: 'Logout', url: 'logout'});
      
      return menu;
    },
    ...mapState({
      loggedIn: state => state.loggedIn,
      isAdmin: state => state.isAdmin
    })
  }
  
,
  methods: {
    navigate (url) {
      if(url === 'logout') {
        this.logout();

      }
      else {
        this.$router.push(url);
      }
     
    },
    logout () {
      firebase.auth().signOut().then(() => {
        this.$store.commit('logout');
        this.$router.replace('login');
      });
    }
  }
}
</script>
